import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/shared/api';
import type { TToolType } from '@intone/shared/types';

/** Hook to list all tool types */
export function useToolTypes() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['tool-types'],
    queryFn: async () => {
      return apiClient<TToolType[]>('/tool-types');
    },
  });
}